// extracted by mini-css-extract-plugin
export default {"users":"internalUser_users__H1qPk","userWelCard":"internalUser_userWelCard__ONlas","userTableCard":"internalUser_userTableCard__VFMRJ"};